const SLUG = /^[a-z][a-z0-9-]{1,38}[a-z0-9]$/;

/**
 * O tenant é resolvido pelo endereço de acesso (A9): `aurora.localhost:47173` em
 * desenvolvimento, `aurora.hive.example` em produção. Não existe seletor de tenant na plataforma.
 */
export function slugFromHost(hostname: string): string | null {
  const h = hostname.toLowerCase();
  if (h === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(h) || h.startsWith('[')) return null;
  const first = h.split('.')[0] ?? '';
  return SLUG.test(first) ? first : null;
}

/**
 * Empresa fixada na instalação (<meta name="hive-tenant">, gravada no boot do contêiner a partir de HIVE_TENANT_SLUG):
 * console num endereço compartilhado ou num subcaminho (apps.empresa.example/hive), onde o primeiro nome do endereço
 * não é o da empresa. Vazia, vale o endereço.
 */
export function configuredSlug(): string | null {
  const v = document.querySelector('meta[name="hive-tenant"]')?.getAttribute('content')?.trim().toLowerCase() ?? '';
  return SLUG.test(v) ? v : null;
}

/** A empresa desta console: a fixada na instalação, senão a do endereço. */
export function currentSlug(hostname: string = window.location.hostname): string | null {
  return configuredSlug() ?? slugFromHost(hostname);
}
